var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1719 2C18.4482 2 17.7244 2.27562 17.1719 2.82812L16 4L20.0001 8L21.172 6.82812C22.276 5.72412 22.276 3.93313 21.172 2.82812C20.6195 2.27562 19.8957 2 19.1719 2ZM13.8519 6L4 15.8519C4 15.8519 5.04222 15.857 5.55556 16.3704C6.06889 16.8837 6.05787 17.9097 6.05787 17.9097C6.05787 17.9097 7.11526 17.9301 7.62963 18.4444C8.144 18.9588 8.14815 20 8.14815 20L18 10.1481L13.8519 6ZM2.66449 18L2.00717 21.5096C1.95408 21.7961 2.20391 22.0459 2.49038 21.9928L6 21.3355L2.66449 18Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconFigma);
export default __webpack_public_path__ + "static/media/edit-icon-figma.20005384a62ecc25c885e4342f185ae0.svg";
export { ForwardRef as ReactComponent };